import { Injectable } from '@angular/core';
import { Subject, shareReplay } from 'rxjs';
import { DATABASE_KEY } from 'src/app/core/utils/global-variable';
import { Cart } from 'src/app/interfaces/common/cart';
import { ReloadService } from '../core/reload.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {ResponsePayload} from '../../interfaces/core/response-payload.interface';


const API_URL = environment.apiBaseLink + '/api/cart/';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  // REFRESH LOCAL STORED CART
  private refreshStoredCart = new Subject<void>();

  /**
   * REFRESH LOCAL STORED CART FUNCTIONS
   * refreshStoredCart$()
   * needRefreshStoredCart$()
  */
  get refreshStoredCart$() {
    return this.refreshStoredCart;
  }

  needRefreshStoredCart$() {
    this.refreshStoredCart.next();
  }

  // STORE CART DATA
  private cartList: Cart[] = [];

  constructor(
    private httpClient: HttpClient,
    private reloadService: ReloadService
  ) { }

  /**
   * addToCart
   * getCartByUserId
   * deleteCartById
   * updateCartById
   * updateCartQty
   */

  getCartByUser() {
    return this.httpClient.get<{ data: Cart[], count: number, success: boolean }>(API_URL + 'get-carts-by-user').pipe(shareReplay());
  }

  addToCart(data: Cart) {
    return this.httpClient.post<ResponsePayload>
    (API_URL + 'add-to-cart', data);
  }

  addToCartMultiple(data: Cart[]) {
    return this.httpClient.post<ResponsePayload>
    (API_URL + 'add-to-cart-multiple', data);
  }

  updateCartQty(id: string, data: { selectedQty: number, type: string }) {
    return this.httpClient.put<{ message: string, success: boolean, type: string }>(API_URL + 'update-qty/' + id, data);
  }

  deleteCartById(id: string, checkUsage?: boolean) {
    let params = new HttpParams();
    if (checkUsage) {
      params = params.append('checkUsage', checkUsage);
    }
    return this.httpClient.delete<ResponsePayload>(API_URL + 'delete/' + id, {params});
  }


  /**
   * CART LOCAL STORAGE
   * addCartItemLocalStorage()
   * getCartItemFromLocalStorage()
   * deleteCartItemFromLocalStorage()
   * deleteAllCartFromLocal()
  */
  addCartItemLocalStorage(cartItem: Cart) {
    const items = JSON.parse(localStorage.getItem(DATABASE_KEY.userCart))
    let carts;
    if (!items) {
      carts = [];
      carts.push(cartItem);
    }
    else {
      carts = items;
      const fIndex = carts.findIndex((o) => o.product === cartItem.product && o.priceId === cartItem.priceId);

      if (fIndex === -1) {
        carts.push(cartItem);
      }
      else {
        // Increment quantity when adding same product (matches backend addToCart $inc behavior)
        carts[fIndex].selectedQty = (carts[fIndex].selectedQty || 0) + (cartItem.selectedQty || 1);
      }
    }
    localStorage.setItem(DATABASE_KEY.userCart, JSON.stringify(carts));
  }

  getCartItemFromLocalStorage(): Cart[] {
    const carts = localStorage.getItem(DATABASE_KEY.userCart);
    if (carts === null) {
      return [];
    }
    else {
      return JSON.parse(carts) as Cart[];
    }
  }

  deleteCartItemFromLocalStorage(id: string, priceId?: string) {
    const items = JSON.parse(localStorage.getItem(DATABASE_KEY.userCart));
    const fIndex = items?.findIndex((item: any) => item.product === id && item.priceId === priceId);
    items?.splice(fIndex, 1);
    localStorage.setItem(DATABASE_KEY.userCart, JSON.stringify(items));
  }

  deleteAllCartFromLocal(refresh?: boolean) {
    localStorage.removeItem(DATABASE_KEY.userCart);
    this.reloadService.needRefreshCart$(refresh ? refresh : false);
  }

  /**
   * CART STORE & GET LOCALLY
   * updateCartList()
   * cartItems()
  */
  public updateCartList(data: Cart[]) {
    this.cartList = data;
    this.needRefreshStoredCart$();
  }

  public get cartItems() {
    return [...this.cartList];
  }

}
